import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../../../services/home.service';

import { users } from '../../../interfaces/users';
import { LanguageServiceService } from '../../../services/language-service.service';
import { LogoutService } from '../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

import { ExcelExportService } from '../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import { UserService } from '../../../services/user';
@Component({
  selector: 'app-allusersmobile',
  templateUrl: './allusersmobile.component.html',
  styleUrl: './allusersmobile.component.scss'
})
export class AllusersmobileComponent {

  allData: users[] = [];
  displayedColumns: string[] = ['username', 'first_name', 'last_name', 'phone', 'type', 'instagram_link',
    'tiktok_link', 'facebook_link'];
  imageURL = '/assets/Home.png';
  isActive = true;
  h5Active = false;
  arabicLag = false;
  classToggled: boolean = false;
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  searchTerm: any = [];

  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;

  city_id?: number;

  id?: string;
  isAr: boolean = localStorage.getItem("language") == "ar";
  isAdmin: boolean = localStorage.getItem("accounttype") == "1";
  categories = [
    { id: 1, name: 'cat', nameAr: 'cat' },
    { id: 2, name: 'dog', nameAr: 'dog' },
  ];
  dataSource: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _languageService: LanguageServiceService,
    private _userService: UserService,
    private fb: FormBuilder,
    private excelExportService: ExcelExportService,
  ) { this.dataSource = new MatTableDataSource(this.allData) }

  ngOnInit(): void {

    this._userService.getAccountType().subscribe({
      next: (data) => {
        if (data['user_type'] == 1) {
          this.isAdmin = true;
        }
        this.getAllUsers();
      },
      error: (error) => console.error(error),
    });

  }
  go(url: string) {
    console.log(url)
    window.open(url);
  }
  deleteuser(id: string) {


    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "نعم" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._homeService.deleteUser(id).subscribe({
          next: (res) => {
            this.getAllUsers();
          },
          error: (err) => console.log(err),
        });
      }
    });


  }
  changeUrl(url: string): string {
    if(url == "https://backendtest.blueboxpet.com/storage")
    {return '/assets/Frameboy.png'}
    else{
    return url.replace('/storage', '');
    }
  }
  edituser(itemobj: any) {

    this.router.navigate(['/Resigter'], { queryParams: itemobj });

  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('userstable', 'Ahmed_Elshahat_Users', ['delete']);
  }
  showpassword(password: any) {
    alert("user password is " + password);
  }
  fixImageUrl(image: any) {
    console.log(image)
    https://backendtest.blueboxpet.com/storage/app/public/uploads/names/bTfD2W9S9j7Hlmk3SYGiRAix9dlbc4w6NDMmZugR.jpg
    return image == null ? "/assets/Frameboy.png" : "https://backendtest.blueboxpet.com/storage/app/public/" + image;
  }
  
  getAllUsers() {
    this.contentReady = true;
    this.searched = false;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allData = data.reverse();
        this.contentReady = false;
        if (this.allData.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
      },
      error: (error) => console.error(error),
    });
  }
}
